import {
  Hero,
  WhoWeAre,
  Marquee,
  WhatWeDo,
  FeaturedProgrammes,
  Impact,
  HumanitarianProjects,
  Magazine,
  Partners,
  FinalCTA,
} from '@/components/sections'
import { usePageTitle } from '@/hooks'

export const HomePage = () => {
  usePageTitle('Home')

  return (
    <>
      <Hero />
      <WhoWeAre />
      <Marquee />
      <WhatWeDo />
      <FeaturedProgrammes />
      <Impact />
      <HumanitarianProjects />
      <Magazine />
      <Partners />
      <FinalCTA />
    </>
  )
}
